const formatToDollar = (value: number) => {
  const priceWithDecimals = `${value}`.padStart(3, "0");
  const priceWithDotBeforeLastTwoDigits = priceWithDecimals.substring(0, priceWithDecimals.length - 2)
    + "." + priceWithDecimals.substring(priceWithDecimals.length - 2);

  return priceWithDotBeforeLastTwoDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default formatToDollar
